import { NgModule } from '@angular/core';

// ngx-filesaver v21+ no longer ships an NgModule. FileSaverService is providedIn: 'root'
// and FileSaverDirective is a standalone directive — components import it directly.
// This wrapper is kept empty to preserve existing imports across the app.
@NgModule({})
export class FilesaveModule {}
